import { useEffect, useReducer } from 'react';

const ACTIONS = {
  RESET: 'RESET',
  FETCH_INIT: 'FETCH_INIT',
  SET_CAN_CREATE: 'SET_CAN_CREATE',
  FETCH_FAILURE: 'FETCH_FAILURE'
};

const dataReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.RESET:
      return {
        canCreate: false,
        isLoading: true
      };
    case ACTIONS.SET_CAN_CREATE:
      return {
        canCreate: action.payload,
        isLoading: false,
        error: false,
        retry: null
      };
    case ACTIONS.FETCH_INIT:
      return {
        isLoading: true
      };
    case ACTIONS.FETCH_FAILURE:
      return {
        canCreate: false,
        isLoading: false,
        error: true,
        retry: action.payload.retry
      };
    default:
      throw new Error();
  }
};

export default (plugin, createFormProps) => {
  const [{ error, isLoading, canCreate, retry }, dispatch] = useReducer(dataReducer, {
    canCreate: false,
    isLoading: true
  });

  useEffect(() => {
    dispatch({ type: ACTIONS.RESET });
    return () => plugin?.clearCache?.();
  }, [plugin]);
  useEffect(() => {
    let cancel;
    if (plugin) {
      if (plugin.canCreate) {
        const fetchCanCreate = () =>
          plugin
            .canCreate(createFormProps)
            .then(res => !cancel && dispatch({ type: ACTIONS.SET_CAN_CREATE, payload: res }))
            .catch(error => {
              console.error('Error user permissions', error);
              if (!cancel) {
                dispatch({ type: ACTIONS.FETCH_FAILURE, payload: { retry: fetchCanCreate }});
              }
            });
        fetchCanCreate();
      } else {
        dispatch({ type: ACTIONS.SET_CAN_CREATE, payload: false });
      }
    }
    return () => {
      cancel = true;
    };
  }, [plugin, createFormProps]);

  return {
    error,
    isLoading,
    canCreate,
    retry
  };
};
